module.exports = __webpack_public_path__ + "img/back1.46deea3d.jpg";